import React from 'react';

type Props = {
  children: React.ReactNode;
  gray?: boolean;
};

function ModalFooter({ children, gray = true }: Props) {
  const classes = ['card-footer', 'px-4', 'py-4', 'sm:px-6', 'rounded-b-md'];

  if (gray) {
    classes.push('bg-gray-50');
  } else {
    classes.push('bg-white');
    classes.push('border-t', 'border-gray-200');
  }

  return <div className={classes.join(' ')}>{children}</div>;
}

export default ModalFooter;
